<template>
  <div class="bookShelf-body">
    <sideBar/>
    <div class="main">
<!--            <h2> &#45;&#45; 我的书架</h2>-->
      <ul class="book-list">
        <li class="book-item" @click="$router.push({ path: '/bookReader' })">
          <div class="book-pic-box">
            <img src="@/assets/images/books/bookExample/book-cover.png">
          </div>
          <div class="book-txt">
            <h3 title="文旌.数字教材">文旌.数字教材</h3>
            <p>金企鹅数字教材研发中心</p>
            <!--                            <p>阅读进度：46%</p>-->
            <span class="tag">试读</span>
          </div>
        </li>
        <li class="book-item" @click="$router.push({ path: '/bookReader', query: { book_id: 1 } })">
          <div class="book-pic-box">
            <img src="@/assets/images/books/book1/book-cover.png">
          </div>
          <div class="book-txt">
            <h3 title="机械制图与AutoCAD">机械制图与AutoCAD</h3>
            <p>主审 胡震</p>
            <p>主编 邵永山 韦兰花</p>
            <!--                            <p>阅读进度：46%</p>-->
            <span class="tag">试读</span>
          </div>
        </li>
        <li class="book-item" @click="$router.push({ path: '/bookReader', query: { book_id: 2 } })">
          <div class="book-pic-box">
            <img src="@/assets/images/books/book2/book-cover.png">
          </div>
          <div class="book-txt">
            <h3 title="新时代大学英语——综合教程2">新时代大学英语——综合教程2</h3>
            <p>主审 张森</p>
            <p>主编 丁国声 滕婷婷 刘学</p>
            <!--                            <p>阅读进度：46%</p>-->
            <span class="tag">试读</span>
          </div>
        </li>
      </ul>
      <div class="bg-logo"><img src="@/assets/images/common/right-bottom-logo.png"></div>
    </div>
  </div>
</template>

<script>
  import sideBar from '@/layout/sideBar.vue'
  export default {
    name: "BookShelf",
    components: {
      sideBar
    }
  }
</script>

<style scoped lang="scss">
.bookShelf-body {
  width: 100%;
  height: 100%;
  display: flex;
  .main {
    width: calc(100% - 70px);
    padding: 20px 50px;
    position: relative;
    h2 {
      font-size: 24px;
      padding: 30px 0;
      text-align: left;
      border-bottom: 1px solid #2F4058;
    }
    .book-list {
      margin: 50px 0;
      display: flex;
      flex-wrap: wrap;
      gap: 50px;
      justify-content: flex-start;
      align-items: flex-start;
      align-content: space-between;
      .book-item {
        padding: 20px;
        width: 400px;
        height: 175px;
        border: 1px solid #e3e3e3;
        display: flex;
        align-items: center;
        position: relative;
        &:hover{
          background: #f7f7f7;
          border-color: #f7f7f7;
        }
        .book-pic-box {
          margin-right: 20px;
          width: 88px;
          height: 120px;
          img {
            width: 100%;
          }
        }
        .book-txt{
          h3 {
            font-size: 18px;
            line-height: 28px;
            height: 60px;
            display: -webkit-box;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          p {
            font-size: 14px;
            margin-top: 6px;
          }
          span.tag {
            display: block;
            font-size: 14px;
            color: #fff;
            font-weight: bold;
            padding: 4px 10px;
            border-radius: 4px;
            background: #E9712B;
            position: absolute;
            bottom: 30px;
            right: 20px;
          }
        }
      }
    }
    .bg-logo {
      width: 131px;
      height: 35px;
      position: absolute;
      right: 30px;
      bottom: 30px;

      img{
        width: 100%;
         opacity: 0.15;
      }
    }
  }
}
</style>
